import './index.css';

export default ({onClick, finished, disable = false, children}) => {

    return (
        <button
            className={`custom-button${finished ? ' custom-button-finished' : ' custom-button-default'}${disable ? ' custom-button-disable' : ''}`}
            onClick={onClick}>{children}</button>
    )
}